import rehypeKatex from 'rehype-katex'
import rehypePrism from 'rehype-prism-plus'
import remarkGfm from 'remark-gfm'
import remarkMath from 'remark-math'
import type { PluggableList } from 'unified'

type MdxPreviewMdxOptions = NonNullable<
  NonNullable<Parameters<typeof import('next-mdx-remote/serialize').serialize>[1]>['mdxOptions']
>

const rehypeKatexPlugin: PluggableList[number] = [
  rehypeKatex,
  {
    strict: false,
    output: 'html' as const,
    throwOnError: false,
    trust: true,
    displayMode: false
  }
]

function getRehypePlugins(options: {
  scrollSyncRehypePlugin?: PluggableList[number]
}): PluggableList {
  const list: PluggableList = [[rehypePrism, { ignoreMissing: true }], rehypeKatexPlugin]
  if (options.scrollSyncRehypePlugin !== undefined) {
    list.push(options.scrollSyncRehypePlugin)
  }
  return list
}

export function getMdxPreviewMdxOptions(options: {
  scrollSyncRehypePlugin?: PluggableList[number]
}): MdxPreviewMdxOptions {
  console.log('getMdxPreviewMdxOptions', options)
  return {
    remarkPlugins: [remarkGfm, remarkMath],
    rehypePlugins: getRehypePlugins(options)
  }
}
